export const APP_FONT_FAMILIES = [
  'Arial',
  'Helvetica',
  'Times New Roman',
  'Courier New',
  'Verdana',

  'edugroove-hand',
  'edugroove-hand-arrows',
  'edugroove-dots',
  'edugroove-happy',

  'DNManuscript',
  'DNManuscriptOutlines',
  'OZManuscript',
  'OZManuscriptOutlines',
  'HWTManuscript',
  'HWTManuscriptOutlines',


  'LettersForLearners',
  'LettersForLearnersDots',
  'LettersForLearnersLined',
  'LettersForLearnersLinedDots',

  'EduAUVICWANTArrows-VariableFont_wght',
  'EduAUVICWANTDots-VariableFont_wght',
  'EduAUVICWANTHand-VariableFont_wght',

  'LondrinaOutline-Regular',
  'BungeeOutline-Regular',

  'ComicRelief-Regular',
  'ComingSoon-Regular',
  'PermanentMarker-Regular',
  'LexendMega-VariableFont_wght',
];

export const preloadAppFonts = async () => {
  if (!document.fonts) return;

  const testText = 'ABC abc 123 The quick brown fox jumps over the lazy dog';

  await Promise.all(
    APP_FONT_FAMILIES.map(async (fontFamily) => {
      try {
        await document.fonts.load(`16px "${fontFamily}"`, testText);
        await document.fonts.load(`bold 16px "${fontFamily}"`, testText);
        await document.fonts.load(`italic 16px "${fontFamily}"`, testText);
      } catch (error) {
        console.warn(`Font preload skipped: ${fontFamily}`, error);
      }
    })
  );

  await document.fonts.ready;
};